import { motion } from "framer-motion";
import { CalendarCheck, Users, Zap, Heart, ArrowRight } from "lucide-react";
import { MaskedLines } from "./ui";
import { scrollToId } from "@/lib/scroll";

const EASE = [0.16, 1, 0.3, 1];

function StatsStrip() {
  const items = [
    { icon: CalendarCheck, a: "Planos", b: "mais cheios" },
    { icon: Users, a: "Clientes", b: "mais fiéis" },
    { icon: Zap, a: "Soluções", b: "mais rápidas" },
    { icon: Heart, a: "Mais tempo", b: "para você" },
  ];
  return (
    <div className="grid grid-cols-2 items-center gap-6 border-y border-black/10 bg-white px-6 py-7 sm:px-10 md:grid-cols-5">
      {items.map((it) => (
        <div key={it.a} className="flex items-center gap-3">
          <it.icon className="h-5 w-5 text-mom-vinho" />
          <p className="font-dmsans text-[10px] font-semibold uppercase leading-relaxed tracking-[0.18em] text-black/70">
            {it.a}<br />{it.b}
          </p>
        </div>
      ))}
      <p className="hidden items-center gap-3 font-dmsans text-[10px] font-semibold uppercase tracking-[0.24em] text-black/50 md:flex md:justify-end">
        Beleza em<br />movimento
        <span className="h-px w-10 bg-mom-carmim" />
      </p>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="topo" className="bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative flex flex-col justify-center overflow-hidden bg-[radial-gradient(circle_at_35%_30%,#C11B3E,#A91532_55%,#8A0F27)] px-6 py-20 sm:px-12 lg:py-28">
          <MaskedLines
            as="h1"
            delay={0.15}
            stagger={0.13}
            className="font-serif text-5xl font-medium leading-[1.02] tracking-tight text-white sm:text-6xl"
            lines={[
              "Não sabe",
              "o que fazer",
              <em key="a" className="italic">agora?</em>,
            ]}
          />
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.75 }}
            className="mt-7 font-serif text-2xl font-medium text-white sm:text-3xl"
          >
            Pergunta pro MOM.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.9 }}
            className="mt-3 font-dmsans text-sm text-white/75"
          >
            Uma situação. Uma missão.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: 1.05 }}
            className="mt-9"
          >
            <button
              data-testid="hero-cta"
              onClick={() => scrollToId("#oferta")}
              className="group inline-flex items-center gap-3 rounded-full bg-white px-7 py-3.5 font-dmsans text-sm font-semibold uppercase tracking-[0.08em] text-black transition-colors duration-300 hover:bg-white/90"
            >
              Começar agora
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 1.25 }}
            className="mt-10 font-dmsans text-[10px] font-medium uppercase tracking-[0.28em] text-white/60"
          >
            Seu assistente inteligente<br />para a vida real do salão
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: EASE }}
          className="relative min-h-[420px] overflow-hidden bg-[#E8E0D5] lg:min-h-[620px]"
        >
          <img
            src="/mom/hero-a.jpg"
            alt="Profissional do salão usando o MOM no celular"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <motion.p
            initial={{ opacity: 0, y: -14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: EASE, delay: 1.1 }}
            className="absolute right-6 top-8 max-w-[180px] text-right font-script text-3xl font-semibold leading-tight text-mom-carmim sm:right-10"
          >
            Mais tempo para o que você ama
          </motion.p>
        </motion.div>
      </div>
      <StatsStrip />
    </section>
  );
}
